export { default } from './SimpleModal';
